<template>
    <transition name="slide-fade">
        <div ref="modal" class="bbox-modal-wrapper" v-if="show">
            <div class="bbox-modal-content" :class="{auto, tiny, normal, big, huge}">
                <focus-lock>
                    <b-card :class="cardClasses">
                        <!-- @slot Slot onde conteúdo do modal é inserido -->
                        <slot />
                        <button tabindex="0" class="close-modal position-absolute position-top-tiny position-right-tiny font-size-xbig border-none bg-transparent">
                            <b-icon v-if="closeable" @click.native="hideModal()"><icon-clear/></b-icon>
                        </button>
                    </b-card>
                </focus-lock>
            </div>
            <div class="bbox-modal-bg bg-ink-base" @click="hideModal()"></div>
        </div>
    </transition>
</template>

<script>
    import BCard from './Card.vue';
    import BIcon from './Icon.vue';
    import FocusLock from 'vue-focus-lock';
    import IconClear from '../icons/icon-clear.svg';

    export default {
        name: 'BModal',
        components: {
            BCard, 
            FocusLock,
            BIcon,
            IconClear
        },
        props: {
            /** 
            * Se false modal não pode ser fechado pelos meios padrões, 
            * apenas utilizando os métodos disponíveis no modal
            */
            closeable: {
                type: Boolean,
                default: true
            },
            /**
             * Se true o conteúdo do modal tem tamanho variável, limitado pela props `tiny, normal, big, huge`
              */
            auto: Boolean,
            /**
             * Se true modal tem `width=400`
              */
            tiny: Boolean,
            /**
             * Se true modal tem `width=600`. Valor padrão se nenhum tamanho é definido
              */
            normal: Boolean,
            /**
             * Se true modal tem `width=800`
              */
            big: Boolean,
            /**
             * Se true modal tem `width=960`
              */
            huge: Boolean,
            /**
             * Classes a serem passadas para o card interno do modal
              */
            cardClasses: {
                type: String,
                default: 'padding-big elevation-16dp'
            }
        },
        data() {
            return {
                show: false,
                defaultStyle: '',
            }
        },
        methods: {
            beforeOpen () {
                this.defaultStyle = document.querySelector('body, html').style.overflow;
                var bodyWidth = document.body.offsetWidth;
                document.querySelector('body, html').style.overflow = 'hidden';
                document.body.style.width = bodyWidth + 'px';
                document.addEventListener('keyup', this.closeListener);
            },
            beforeClose () {
                this.removeOverflowHidden();
                var wrapper = document.querySelector('.bbox-modal-wrapper');
                if(!!wrapper && wrapper.scrollHeight <= wrapper.clientHeight) wrapper.style.overflowY = 'hidden';
                document.removeEventListener('keyup', this.closeListener);
            },
            /**
             * Abre o modal
             * @public
              */
            showModal(){
                this.beforeOpen();
                this.show = true;
                return new Promise(function(resolve) {
                    setTimeout(function() {
                        resolve();
                    }, 200);
                });
            },
            /**
             * Fecha o modal se closeable=true
             * @public
              */
            hideModal(){
                this.beforeClose();
                if(this.closeable) {
                    this.show = false;
                    return new Promise(function(resolve) {
                        setTimeout(function() {
                            resolve();
                        }, 200);
                    });
                }
            },
            /**
             * Força o fechamento do modal independentemente da propriedade closeable
             * @public
              */
            forceHideModal(){
                this.beforeClose();
                this.show = false;
            },
            /**
             * Abre o modal se estiver fechado, e o fecha se estiver aberto
             * @public
              */
            toggleModal(){
                if(this.show) this.beforeClose();
                if(!this.show) this.beforeOpen();
                this.show = !this.show;
                return new Promise(function(resolve) {
                    setTimeout(function() {
                        resolve();
                    }, 200);
                });
            },
            closeListener(e){
                if(e.keyCode === 27) this.hideModal();
            },
            removeOverflowHidden(){
                setTimeout(() => {
                    document.querySelector('body, html').style.overflow = this.defaultStyle;
                    document.body.style.width = 'unset';
                }, 200);
            }
        },
        mounted() {
            // var modal = this.$el;
            // modal.parentElement.removeChild(modal);
            // document.body.appendChild(modal);
        }
    }
</script>

<style lang="scss" scoped>
    $animationDuration: .2s;
    .slide-fade-enter-active {
        transition: all $animationDuration ease;
    }
    .slide-fade-leave-active {
        transition: all $animationDuration ease;
    }
    .slide-fade-enter {
        opacity: 0;
    } 
    .slide-fade-leave-to {
        opacity: 0;
    }
    .slide-fade-enter .bbox-modal-content {
        transform: translateY(-50%);
    }
    .slide-fade-leave-to .bbox-modal-content {
        transform: translateY(50%);
    }

    .close-modal {    
        font-style: normal;
        display: block;
        cursor: pointer;
        padding: 0;
        line-height: 1;
        //color: $lightInk;
    }
    .close-modal:hover {
        //color: $ink;
    }
    div.bbox-modal-wrapper {
        position: fixed;
        padding-top: 2.5rem;
        padding-bottom: 2.5rem;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow-y: auto;
        display: flex;
        box-sizing: border-box;
        z-index: 1000;
    }
    div.bbox-modal-bg {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1000;
        //background-color: $ink;
        opacity: 0.9;
        transform: translate(0,0) !important;
    }
    div.bbox-modal-content {
        max-width: 95vw;
        margin: auto;
        width: auto;
        height: auto;
        z-index: 101;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
        z-index: 1001;
        transition: all $animationDuration ease;
        width: 600px;
        max-width: 95vw;
        &>div {
            width: 100%;
        }
        &.auto>div {
            width: auto;
        }
        &.tiny {
            width: 400px;
        }
        &.normal {
            width: 600px;
        }
        &.big {
            width: 800px;
        }
        &.huge {
            width: 960px;
        }
    }
    div.bbox-modal-content>*:not(.bbox-modal-bg){
        position: relative;
        z-index: 101;
    }
</style>

<docs>
    Caixa de diálogo

    As importações dos arquivos abaixo são necessárias para o funcionamento do componente:
    - spacing.scss
    - colors-classes.scss
    - typography.scss

    Este modal tem como dependência o pacote `vue-focus-lock`

    Para instalar o pacote no seu projeto pode-se usar:
    - `npm i vue-focus-lock`  
    - `yarn add vue-focus-lock`  

    ```js
    <BButton tertiary @clickOrEnter="$refs.modal.showModal()">Abrir modal</BButton>
    <BModal auto ref="modal">
        Este é um modal!
    </BModal>

    <BButton tertiary @clickOrEnter="$refs.tinyModal.showModal()">Tiny</BButton>
    <BModal tiny ref="tinyModal">
        Este é um modal!
    </BModal>

    <BButton tertiary @clickOrEnter="$refs.normalModal.showModal()">Normal</BButton>
    <BModal normal ref="normalModal">
        Este é um modal!
    </BModal>

    <BButton tertiary @clickOrEnter="$refs.bigModal.showModal()">Big</BButton>
    <BModal big ref="bigModal">
        Este é um modal!
    </BModal>

    <BButton tertiary @clickOrEnter="$refs.hugeModal.showModal()">Huge</BButton>
    <BModal huge ref="hugeModal">
        Este é um modal!
    </BModal>
    ```
</docs>